import React, { useRef, useState, useEffect } from 'react';
import { Button, Card, Container, Row, Col, Spinner, Form} from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';
import { toast, ToastContainer } from 'react-toastify';
import ExcelIcon from '../../Assets/ExcelIcon.svg';
import * as XLSX from "xlsx";
import { useSelector } from 'react-redux';

const TelecallingDefaulter = () => {

  const token  = useSelector(state => state.loginData.userData.token);
  const financialYear = useSelector(state => state.activeData.activeMenu.activeTab);
  const formattedFinancialYear = `${financialYear.slice(0, 5)}${financialYear.slice(7)}`;

  const [error, setError]= useState("");
  const [jsonData, setJsonData] = useState([]);
  const [excelFile, setExcelFile] = useState(null);
  const fileInputRef = useRef(null);
  const [dataFilterOptions, setDataFilterOptions] = useState([]);
  const [dataFilter, setDataFilter] = useState('');
  const [dataFilterErr, setDataFilterErr] = useState(false);
  const [loader, setLoader] = useState(false);
  const [submitError, setSubmitError] = useState(false);



  const requiredColumns = [
    "propertyCode", "propertyKey", "propertyContactNo", "propertyName", "propertyAddress", 
    "zonename", "gatname", "arrearsAmount", "currentBill", "totalAmount", "finalUserType", "financialYear", "dataFilter"
  ];

  useEffect(()=>{
    getDataFilterOptions();

    let a = 5;
    // let b = a++;
    console.log("b", a++);

    // console.log("a+b", a+b);
  },[])

  const getDataFilterOptions =  async()=>{
    try{
      const res = await fetch(process.env.REACT_APP_BASE_URL + '/tc/callingFilterList',{
        method:'GET'
      });

      const response = await res.json();
      setDataFilterOptions(response.data);
    }catch(Err){
      console.log("Err while getting DataFilterOptions", Err)
    }
  }


  const handleFileUpload = async (event) => {
    
    const file = event.target.files[0];
    if (!file) return;

        // Check file type
    const validExtensions = ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.ms-excel'];
    const validFileExtensions = ['.xls', '.xlsx'];

    const fileExtension = file.name.substring(file.name.lastIndexOf('.')).toLowerCase();

    if (!validExtensions.includes(file.type) && !validFileExtensions.includes(fileExtension)) {
        setError("Please upload an Excel file.");
        return;
    }

    try {
      setLoader(true);
      setExcelFile(event.target.files[0]);
      const formData = new FormData();
      formData.append("file", event.target.files[0]);
      formData.append("financialYear", formattedFinancialYear);
      formData.append("dataType", dataFilter);
      const res = await fetch(process.env.REACT_APP_BASE_URL + '/tc/updateTelecallingData', {
        method: 'POST',
        body: formData,
      })
      const response = await res.json();
      console.log("res ==>", response)
      setLoader(false);
      // const result = await readExcel(file);
      // setJsonData(result); // Store data to send to API
    } catch (err) {
        setError(err);
        console.error("Err while formData", err);
    }
    finally{
      if (fileInputRef.current) {
          fileInputRef.current.value = ""; // ✅ Reset before processing
        }
    }
  };



  const readExcel = async (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
  
      reader.onload = (event) => {
        const data = new Uint8Array(event.target.result);
        const workbook = XLSX.read(data, { type: 'array' });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const jsonData = XLSX.utils.sheet_to_json(worksheet);
  
        // Check if all required columns are present
        const sheetColumns = Object.keys(jsonData[0] || {});
        const missingColumns = requiredColumns.filter(col => !sheetColumns.includes(col));
  
        if (missingColumns.length > 0) {
          return reject(`Missing columns: ${missingColumns.join(', ')}`);
        }
  
        let validatedData = [];
  
        for (let index = 0; index < jsonData.length; index++) {
          const row = jsonData[index];
          let validatedRow = {};
  
          // Populate all required columns, default to "" if missing
          requiredColumns.forEach((col) => {
            validatedRow[col] = row[col] !== undefined ? row[col] : "";
          });
  
          // Validate propertyCode (must have two decimal places)
          if (!/^-?\d+(\.\d{2})?$/.test(validatedRow.propertyCode)) {
            return reject(`<Strong>Row ${index + 2}</Strong> - PropertyCode must have two decimal places.`);
          }
  
          // Validate financialYear (must be equal to selected dropDown)
          if (validatedRow.financialYear !== formattedFinancialYear) {
            return reject(`<Strong>Row ${index + 2}</Strong> - Financial Year must be ${formattedFinancialYear}.`);
          }
  
          // Validate dataFilter (must match selected filter)
          if (validatedRow.dataFilter !== dataFilter) {
            return reject(`<Strong>Row ${index + 2}</Strong> - Data Type must be ${dataFilter} for this sheet.`);
          }
  
          validatedData.push(validatedRow);
        }
  
        resolve({ data: validatedData });
      };
  
      reader.onerror = (error) => reject(error);
      reader.readAsArrayBuffer(file);
    });
  };

const handleRemoveFile = ()=>{
  if (fileInputRef.current) {
    fileInputRef.current.value = ""; // ✅ Reset before processing
  }
  setExcelFile(null);
  setError("");
}

const submitTeleCalling = async()=>{
  if(!dataFilter){
    setDataFilterErr(true);
    return;
  }

  else if(!excelFile){
    setError("Please upload excel file");
    return;
  }

  else if(error.length > 0){
    setSubmitError("Please resolve above error before submiting.")
    return;   
  }
  try{
    setLoader(true);
    const res = await fetch(process.env.REACT_APP_BASE_URL + '/tc/updateTelecallingData', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
      body: JSON.stringify({  dataFilter, financialYear:formattedFinancialYear, data: jsonData?.data }),
    })

    const response = await res.json();
    if(response.message === "Telecalling data updated successfully"){
      toast.success("Telecalling data updated successfully");
    }
  }
  catch(Err){
    console.log("Err while telecalling defaulter", Err);
    toast.error("Failed, please try again");
  }
  finally{
    setLoader(false);
    setExcelFile(null);
    setError("");
    setDataFilterErr(false);
    setDataFilter("");
  }
}




  return (
    <div className='TelecallingDefaulter'>
         <ToastContainer />

        <Container>
            <div className='d-flex justify-content-center align-items-center'>
              <h3 className='mb-0'>TeleCalling Defaulter (Internal Dev)</h3>
            </div>

            <Row className='justify-content-end me-4'>
              <Button
                href="/Telecalling_Sample_Excel.xlsx" // Make sure the file is inside the "public" folder
                download="Telecalling_Sample_Excel.xlsx"
                className="btn-submit ms-auto w-auto">
                <Icon.ArrowDownCircle className='me-2'/> Download Sample Excel
              </Button>
            </Row>

            <Row className='justify-content-center my-4'>
              <Col md={4}>
                <Card>
                    <Card.Header className='py-3'>
                      <h5 className='text-center mb-0'>Upload Bulk Excel</h5>
                    </Card.Header>

                    <Card.Body className='px-4'>
                    <div className='mt-2 mb-3 justify-content-center'>
                      <Form.Label><span className='me-1'>*</span> Data Type</Form.Label>
                     
                     <Form.Select  value={dataFilter}
                     onChange={(e) => {setDataFilter(e.target.value); setExcelFile(null); setError("") }}>
                       <option value="" selected disabled>
                         {" "}
                         Select Data Type
                       </option>
                       {dataFilterOptions !== undefined && dataFilterOptions.length > 0 ? (
                         dataFilterOptions.map((row) => {
                           return (
                             <option value={row.value}>{row.label} </option>
                           );
                         })
                       ) : (
                       <option value="">No Data Found</option>
                      )}
                     </Form.Select>
                     {dataFilterErr && <p className='errMsg'>Please select data type to proceed</p>}
                      </div>
            {
                dataFilter &&

                            <div className='mt-4 mb-2 d-flex justify-content-center'>
                              {
                                excelFile!==null ? (
                                  <Card className='uploadedFile text-center px-3 py-3 mx-auto'>
                                    <img src={ExcelIcon} width={40} className='mx-auto mb-2'/>
                                    <p className='mb-0'>{excelFile?.name}</p>
                                    <Icon.XCircleFill className='removeIcon' size={18}
                                        onClick={handleRemoveFile} />
                                  </Card>
                              ) : 
                            
                            <div>
                                <input type="file" id="fileInput"
                                ref={fileInputRef} 
                                  accept=".xlsx, .xls"
                                  style={{ display: "none" }}
                                  onChange={(e) => handleFileUpload(e)}/>

                                  <label htmlFor="fileInput" className="uploadFile" style={{cursor:'pointer'}}>
                                    <Icon.CloudUpload className='me-2'/>Click here to upload file
                                  </label>

                              </div>
                            }
                            
                            </div>
            }

            {error && <p className='errMsg' dangerouslySetInnerHTML={{ __html: error }}/>}
                    </Card.Body>

                    <Card.Footer>
                      { submitError && <p className='errMsg text-center mb-1'>{submitError}</p>}
                      {
                        loader ? <center><Spinner /></center> :
                      <Button className='btn-submit ms-auto' onClick={submitTeleCalling}>
                         <Icon.Send className='me-2' size={14}/> Submit
                      </Button>
                      }
                    </Card.Footer>
                </Card>
              </Col>
            </Row>


            </Container>
    </div>
  )
}

export default TelecallingDefaulter;